import styled from 'styled-components';
import { themeNames } from '@upgrade/themes';
import { fontSize } from '../Typography/mixins';
export const Footer = styled.footer`
  border-top: ${props => props.theme.name === themeNames.UPGRADE_THEME_NAME ? `1px solid ${props.theme.palette.border}` : 'none'};
`;
export const InlineBlock = styled.li`
  display: inline-block;
`;
export const Legal = styled.div`
  ${fontSize('xs')}
  color: ${props => props.theme.palette.contentWeak};
  a:not([data-type='unstyled']) {
    color: ${props => props.theme.palette.actionableSecondary};
    border-bottom: 1px solid ${props => props.theme.palette.actionableSecondary};
  }

  a,
  a:hover,
  a:focus,
  a:active {
    text-decoration: none;
  }
`;
export const ContactEmail = styled.span`
  color: ${props => props.theme.palette.actionablePrimary};
`;
//# sourceMappingURL=styles.js.map